import CloseIcon from '@mui/icons-material/Close';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, styled } from '@mui/material';
import React, { useState } from 'react';
import { MdDownload } from 'react-icons/md';

import WsColors from '../../WsColors';

interface IFilePreviewProps {
  url: string;
  onViewClick?: () => Promise<string>;
  onDownload?: () => void;
  onClose?: () => void;
  requireDownloadIcon?: boolean;
  hideViewIcon?: boolean;
  requireCloseIcon?: boolean;
}
const StyledIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.grey[500],
  position: 'absolute',
  right: 0,
  top: 0,
}));
const WsFilePreview = ({
  url,
  onViewClick = async () => '',
  onDownload,
  requireDownloadIcon = false,
  hideViewIcon = false,
  onClose,
  requireCloseIcon = false,
}: IFilePreviewProps) => {
  const [fileUrl, setFileUrl] = useState<string>(url);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const onClick = async () => {
    const latestUrl = await onViewClick();
    setFileUrl(latestUrl ?? url);
    openImgDialog();
  };
  const openImgDialog = () => setOpenDialog(!openDialog);
  return (
    <Box>
      {!hideViewIcon && (
        <IconButton size="small" sx={{ p: 0.2, m: 0 }} onClick={onClick}>
          <RemoveRedEyeOutlinedIcon color="primary" fontSize="small" />
        </IconButton>
      )}
      {requireDownloadIcon && onDownload && (
        <IconButton size="small" sx={{ p: 0.2, m: 0 }} onClick={onDownload}>
          <MdDownload color={WsColors.TheBlues500} size={23} />
        </IconButton>
      )}
      {requireCloseIcon && onClose && (
        <IconButton size="small" sx={{ p: 0.2, m: 0 }} onClick={onClose}>
          <CloseIcon color="error" fontSize="small" />
        </IconButton>
      )}
      <Dialog open={openDialog} maxWidth="md">
        <DialogTitle>
          {onDownload && (
            <StyledIconButton sx={{ right: 30 }} onClick={onDownload}>
              <MdDownload color={WsColors.TheBlues500} size={23} />
            </StyledIconButton>
          )}
          <StyledIconButton onClick={openImgDialog}>
            <CloseOutlinedIcon />
          </StyledIconButton>
        </DialogTitle>
        <DialogContent>
          <img src={fileUrl} alt="img" width="100%" />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default WsFilePreview;
